import { render, staticRenderFns } from "./Skills-Certificate.vue?vue&type=template&id=4269d6cc&scoped=true"
import script from "./Skills-Certificate.vue?vue&type=script&lang=js"
export * from "./Skills-Certificate.vue?vue&type=script&lang=js"
import style0 from "./Skills-Certificate.vue?vue&type=style&index=0&id=4269d6cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4269d6cc",
  null
  
)

export default component.exports